import http from "../services/httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/nRouters/";
const url = apiUrl + endPoint;

export async function getRouters() {
  return await http.get(url);
}

export async function getRouterById(routerId) {
  return await http.get(url + routerId);
}

export async function deleteRouter(routerId) {
  return await http.delete(url + routerId);
}

export async function addRouter(router) {
  return await http.post(url, router);
}

export async function updateRouter(router) {
  const payload = { ...router };
  const routerId = payload._id;
  delete payload._id;
  return await http.put(url + routerId, payload);
}

export async function pingRouter(routerId) {
  return await http.put(url + "ping/" + routerId);
}
